import { render } from "./producttype.vue?vue&type=template&id=5402dbe3"
import script from "./producttype.vue?vue&type=script&lang=js"
export * from "./producttype.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__